import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValueChangeEvent, Validators } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { DynamicFormGroupComponent } from '../dynamic-form-group/dynamic-form-group.component';
import { QuestionBase, FormGroupQuestion } from '../../classes/questions';

import { CreateSubscriptionDialogComponent, StripeBody } from '../create-subscription-dialog/create-subscription-dialog.component';

export interface SubEditorData {
  customer?: any,
  stripeBody?: StripeBody,
  customerId?: string,
  editType: string
}


@Component({
  selector: 'app-subscription-editor',
  imports: [
    FormsModule, ReactiveFormsModule,
    MatTabsModule,
    DynamicFormComponent,
    CreateSubscriptionDialogComponent
  ],
  templateUrl: './subscription-editor.component.html',
  styleUrl: './subscription-editor.component.css'
})
export class SubscriptionEditorComponent implements OnInit {

  form!: FormGroup;
  priceBuilderForm!: FormGroup;
  subForm!: FormGroup;
  subId: string = '';
  updatePricing: boolean = false;
  updateSchedule: boolean = false;

  readonly dialogRef = inject(MatDialogRef<SubscriptionEditorComponent>);
  readonly dialog = inject(MatDialog);
  readonly data = inject<SubEditorData>(MAT_DIALOG_DATA);

  /**
  * On submit we call the stripeApi to create the subscription object in Stripe
  */
  async onSubmit() {
    if (this.subForm.dirty) {
      console.log('onSubmit subForm changed');
    }
    if (this.priceBuilderForm.dirty) {
      console.log('onSubmit priceBuilderForm changed');
    }
    //this.payLoad = this.form.getRawValue();
    /*this.setStripeSubscriptionValuesService();
    if (this.payLoad.add_cancellation_credit && this.payLoad.cancellation_credit_amount !== 0) {
      this.addCustomerCredit()
    }
    else {
      this.createStripeSubSession();
    }*/
  }

  ngOnInit() {
    this.updatePricing = this.data.editType == 'edit_services_or_pricing';
    this.updateSchedule = this.data.editType == 'edit_schedule';
    console.log('SubscriptionEditorComponent data', this.data);
    if (this.data.stripeBody && this.data.stripeBody.metadata.appSubId){
      this.subId = this.data.stripeBody.metadata.appSubId;
    }
    else if (this.data.stripeBody && this.data.stripeBody.metadata.appId){
      this.subId = this.data.stripeBody.metadata.appId;
    }
    const parsedUrl = new URL(window.location.href);
    //this.subValueMap = {customerId: this.data.customer.id}
  }

}
